import { Children } from 'react';

import classNames from '../../utils/classNames';
import LoadingSpinner from '../loadingSpinner/LoadingSpinner';

export const SUGGESTIONS_POPOVER_BASE_CLASSNAME =
    'z-20 rounded border border-neutral-200 bg-white text-sm shadow-lg';
export const SUGGESTIONS_ITEM_BASE_CLASSNAME =
    'flex w-full px-3 py-2 text-left hover:bg-neutral-100 data-[active-item]:bg-neutral-100';

export interface SuggestionsListProps {
    isLoading?: boolean;
    showEmptyState?: boolean;
    listClassName?: string;
    children?: React.ReactNode;
    emptyState?: React.ReactNode;
}

export default function SuggestionsList({
    isLoading = false,
    showEmptyState = false,
    listClassName,
    children,
    emptyState,
}: SuggestionsListProps) {
    const hasItems = Children.count(children) > 0;

    if (isLoading) {
        return (
            <div className="flex items-center gap-2 px-3 py-2 text-neutral-500">
                <LoadingSpinner />
                <span>{gettext('LOADING')}</span>
            </div>
        );
    }

    if (hasItems) {
        return (
            <div className={classNames('max-h-60 overflow-auto py-1', listClassName)}>
                {children}
            </div>
        );
    }

    if (showEmptyState) {
        return (
            <div className="text-neutral-500">
                {emptyState ?? <div className="px-3 py-2">{gettext('NO_RESULTS_FOUND')}</div>}
            </div>
        );
    }

    return null;
}
